import React from 'react';
import { Grid, Alert, FormControl, FormLabel } from "@gti-controls-v2/web-core";
import homeStyles from '../../../common/styles/HomePage';

export const SecondaryTitle = ({
    data
}) => {
    const styles = homeStyles;

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sx={styles.secondaryTitle}>
                <Alert icon={false} sx={styles.secondaryTitleContainer}>
                    <Grid container direction="row">
                        {data && data.map((item) => (
                            <Grid item sx={styles.secondaryTitleItem}>
                                <FormControl>
                                    <FormLabel style={{ fontSize: 18 }}>{item.label}</FormLabel>
                                    {item.value}
                                </FormControl>
                            </Grid>
                        ))}
                    </Grid>
                </Alert>
            </Grid>
        </Grid>
    );
};

export default SecondaryTitle;